import React, { useState } from "react";
import LoginForm from "./LoginForm";
import MailForm from "./MailForm";
import LogsPage from "./LogsPage";  // создадим этот компонент

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState("mailing");

  const handleLoginSuccess = () => {
    setLoggedIn(true);
  };

  if (!loggedIn) {
    return <LoginForm onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div>
      <div className="tabs">
        <button onClick={() => setActiveTab("mailing")}>Mailing</button>
        <button onClick={() => setActiveTab("logs")}>Logs</button>
      </div>
      {activeTab === "mailing" && <MailForm />}
      {activeTab === "logs" && <LogsPage />}
    </div>
  );
}

export default App;
